export default "__VITE_ASSET___Dr9LLzD__"